/**
 * Optional Web Push companion worker for incoming call notifications.
 * Enable with VUE_APP_CALL_INVITE_SW=true (requires backend push subscription; see public/call-invite-sw.js).
 */
export async function registerCallInviteWorker() {
  const enabled =
    process.env.VUE_APP_CALL_INVITE_SW === 'true' ||
    process.env.VUE_APP_ENABLE_CALL_INVITE_SW === 'true';
  if (!enabled) return null;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null;
  const root = (process.env.BASE_URL || '/').replace(/\/?$/, '/');
  const swUrl = `${root}call-invite-sw.js`;
  try {
    return await navigator.serviceWorker.register(swUrl, { scope: root });
  } catch (e) {
    console.warn('[calls] call-invite-sw registration failed', e);
    return null;
  }
}
